// @flow

import type { State } from './state'

export const mutations = {
  setHasChatBubbleBeenOpened (state: State, value: boolean) {
    state.hasWebsiteChatBeenOpened = value
  },
  setOpen (state: Object, value: boolean) {
    state.isOpen = value
  }
}
